module.exports = __webpack_public_path__ + "img/sbzc_07.5b8f6060.jpg";